






 // import dir
/* __WebpackModuleApi eslint no-undef solution: https://github.com/facebook/create-react-app/issues/2974 */
let importAll = (requireContext: __WebpackModuleApi.RequireContext) => requireContext.keys().forEach(requireContext)
try {
    importAll(require.context('../assets/icons', true, /\.svg$/));
}catch(error) {
    console.log(error);
}
 export default {
     name: 'Icon',
     props: ['name']
 }
